import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { StaticQuery, graphql } from 'gatsby'
import Img, { FluidObject } from 'gatsby-image'

import { FileConnection } from '../graphqlTypes'

type Props = {
  alt?: string
  className?: string
  filename: string
}

export default function Image({ alt, className, filename }: Props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          images: allFile {
            edges {
              node {
                extension
                publicURL
                relativePath
                childImageSharp {
                  fluid(maxWidth: 2560) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      `}
      render={({ images }: { images: FileConnection }) => {
        const image = images.edges.find((image) => image.node.relativePath === filename)
        if (!image) throw new Error(`Not found image: ${filename}`)

        if (image.node.publicURL && image.node.extension === 'svg')
          return (
            <LazyLoadComponent>
              <img alt={alt} src={image.node.publicURL} />
            </LazyLoadComponent>
          )

        if (!image.node.childImageSharp) throw new Error(`Not found image: ${filename}`)

        return (
          <Img
            fadeIn
            alt={alt || ''}
            className={className}
            durationFadeIn={350}
            fluid={image.node.childImageSharp.fluid as FluidObject}
            loading="lazy"
          />
        )
      }}
    />
  )
}
